import { IForgotPassword, IResetPassword } from "@/@types/ForgotPassword";
import { api } from "./api";

async function forgotPassword(data: IForgotPassword): Promise<void> {
  await api.post("/v1/authentication/forgot-password", {
    ...data,
    email: data.email?.trim().toLowerCase(),
  });
}

async function resetPassword(data: IResetPassword): Promise<void> {
  await api.post("/v1/authentication/reset-password", {
    ...data,
    email: data.email?.trim().toLowerCase(),
  });
}

export const ForgotPasswordService = { forgotPassword, resetPassword };
